module.exports = __webpack_public_path__ + "img/tips-beginning.fbdac054.svg";